document.addEventListener("DOMContentLoaded", function() {

    // LightGallery inicializace
    // =========================
    if(typeof (lightGallery) === 'undefined')
        return;

    (function () {
        let gallery = document.querySelectorAll('.JS-lightgallery');
        if(typeof(gallery) === 'undefined' || gallery === null)
            return;

        gallery.forEach(function (el) {
            const gal = lightGallery(el, {
                selector: '.JS-lightgallery-item',
                licenseKey: '9F006080-20BA-4E4D-8CD1-1EEF91BC50ED',
                mobileSettings: {
                    controls: true,
                    showCloseIcon: true,
                    download: true
                }
            });
            // po kliku na element js-photo se otevře galerie
            const openPhoto = document.querySelector('.js-photo');
            openPhoto && openPhoto.addEventListener('click', () => {
                gal.openGallery();
            })
        });

        let thumbs = document.querySelector('.thumbnail-container');
        if(typeof(thumbs) === 'undefined' || thumbs === null)
            return;

        lightGallery(thumbs);
    }());
});